import React from 'react';
import { Typography } from '@mui/material';

const CardTitle = ({ children }) => (
    <Typography variant="caption" color="text.secondary" sx={{ fontSize: 14, fontWeight: 700 }}>
        {children}
    </Typography>
);

export default CardTitle;
